var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.video && _vm.newsList
    ? _c("div", { staticClass: "one-content" }, [
        _c("div", { staticClass: "text" }, [
          _vm.newsList[0]
            ? _c("div", { staticClass: "text-h" }, [
                !this.isImages
                  ? _c("img", {
                      attrs: {
                        src: _vm.newsList[0].image,
                        vspace: "0",
                        hspace: "0",
                        align: "right"
                      }
                    })
                  : _c("div", {
                      staticClass: "no_images",
                      attrs: { vspace: "0", hspace: "0", align: "right" }
                    }),
                _c("h3", { staticClass: "no_upper" }, [
                  _vm._v(_vm._s(_vm.newsList[0].title))
                ]),
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.newsList[0].text) }
                }),
                _vm.entry && _vm.show
                  ? _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.entry.text) }
                    })
                  : _vm._e()
              ])
            : _vm._e(),
          _c(
            "a",
            {
              staticClass: "more text-black solid",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.more(_vm.newsList[0].id, $event)
                }
              }
            },
            [
              !this.show ? _c("span", [_vm._v("Свернуть текст")]) : _vm._e(),
              _vm.entry && this.show
                ? _c("span", [_vm._v("Закрыть текст")])
                : _vm._e()
            ]
          )
        ]),
        _vm.video ? _c("div", { staticClass: "content-video" }) : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e2ec661", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e2ec661","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shared/content/ContentText.vue
// module id = 8wML
// module chunks = 0 1 2